const capitalizeWords = (str) => {
  if (!str) return "";
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

// Helper function to get product description based on category
export const getProductDescription = (categoryName) => {
  const name = categoryName?.toLowerCase() || "";

  if (name.includes("controller") || name.includes("control panel")) {
    return "Each module functions as a Server, Client or Elevator | Configured for 32 Doors and 64 Panels";
  }
  if (name.includes("reader") || name.includes("card reader")) {
    return "Secure Smart Card Technology | Modern LED design for a premium look | Mullion mounted";
  }
  if (name.includes("lock") || name.includes("lockset")) {
    return "Limited only by the system's door count capacity | 5 locks per gateway";
  }
  if (name.includes("credential") || name.includes("card")) {
    return "Secure Smart Credential Technology | Laser printed FC and Card Number";
  }
  if (name.includes("accessory") || name.includes("accessories")) {
    return "Auto Resetting Fused Output | Battery Back Up Charging | LED's indication";
  }
  if (name.includes("mini") && name.includes("pc")) {
    return "Browser-managed out-of-the-box setup | Supports up to 25 concurrent administrators";
  }
  if (name.includes("directory") || name.includes("intercom")) {
    return "Two-way video calling and voice communication | Remote door unlock for convenience";
  }
  if (name.includes("license")) {
    return "Feature within the system | One time add on license";
  }
  if (name.includes("license")) {
    return "Feature within the system | One time add on license";
  }
  if (name.includes("poe")) {
    return "International standard 48v, IEEE802.3AT/AF standard | Support 44v-57v wide voltage design";
  }

  return "View complete product specifications and features";
};

// Menu items configuration
export const getKeyFeaturesItems = () => [
  {
    label: "User Interface",
    description: "Intuitive dashboard for system management",
    icon: "🖥️",
    link: "/user-interface",
    key: "0",
  },
  {
    label: "RMC Remote Management Cloud",
    description: "Cloud-based remote access control",
    icon: "☁️",
    link: "/cloud",
    key: "1",
  },
  {
    label: "RMC Plus Cloud Management",
    description: "Enhanced cloud management features",
    icon: "⭐",
    link: "/cloud-plus",
    key: "2",
  },
  {
    label: "True Cloud Solution",
    description: "100% cloud-based solution",
    icon: "🌐",
    link: "/true-cloud",
    key: "3",
  },
  {
    label: "Mobile Management",
    description: "Manage systems on-the-go",
    icon: "📱",
    link: "/mobile-link",
    key: "4",
  },
  {
    label: "Video Integration",
    description: "NVR and camera integration",
    icon: "📹",
    link: "/video-integration",
    key: "5",
  },
  {
    label: "Video Recording and Tagging",
    description: "Event-based video management",
    icon: "🎥",
    link: "/video-recording-tagging",
    key: "6",
  },
  // {
  //   label: "Directory",
  //   description: "Comprehensive directory management",
  //   icon: "📂",
  //   link: "/directory",
  //   key: "8",
  // },
  {
    label: "Tenant Video Directory Intercom",
    description: "Building communication system",
    icon: "🏢",
    link: "/tenant-video",
    key: "7",
  },
  {
    label: "Wireless Locksets",
    description: "Smart lock integration",
    icon: "🔒",
    link: "/schlage-lockset",
    key: "8",
  },
  {
    label: "Badging",
    description: "ID card and credential management",
    icon: "🎫",
    link: "/badging",
    key: "9",
  },
  {
    label: "E3 Take Over and Retrofit",
    description: "Legacy system upgrade solutions",
    icon: "🔄",
    link: "/e3-takeover",
    key: "10",
  },
  {
    label: "Installer",
    description: "Fast on-site device setup and configuration",
    icon: "⚙️",
    link: "/installer",
    key: "11",
  },
  {
    label: "Credential",
    description: "Secure smart credential management",
    icon: "◊",
    link: "/credential",
    key: "12",
  },
  {
    label: "Directory",
    description: "Comprehensive directory and contact management",
    icon: "📋",
    link: "/directory",
    key: "13",
  },
  {
    label: "Mobile Pro",
    description: "Advanced mobile access control management",
    icon: "📲",
    link: "/mobile-pro",
    key: "14",
  },
];

export const getSupportItems = (isLoggedIn) => [
  {
    label: "Mobile Applications",
    description: "Download iOS and Android apps",
    icon: "📲",
    link: "/mobile-applications",
    key: "0",
  },
  {
    label: "Neptune 1.0 Legacy Website",
    description: "Access legacy system Neptune 1.0",
    icon: "🌊",
    link: "https://beorak.cafe24.com",
    key: "1",
    external: true,
  },
  {
    label: "Neptune 2.0 Platform",
    description: "Experience the latest platform Neptune 2.0",
    icon: "🚀",
    link: "#demo",
    key: "2",
    action: "demo",
  },
  {
    label: "Migration Guide",
    description: "Migrate from Neptune 2.0 to 1.0",
    icon: "⬆️",
    link: "/migrate-neptune",
    key: "3",
  },

  ...(isLoggedIn
    ? [
        {
          label: "Documentation Library",
          description: "Guides and manuals",
          icon: "📚",
          link: "/documentation-library",
          key: "4",
        },
        {
          label: "Tutorial Video Library",
          description: "Video guides and tutorials",
          icon: "🎥",
          link: "/tuitorial-library",
          key: "5",
        },
      ]
    : []),

  {
    label: "Warranty Policy",
    description: "Product warranty information",
    icon: "📜",
    link: "/warrantypolicy",
    key: "12",
  },
  {
    label: "Privacy Policy",
    description: "Data protection and security",
    icon: "🔒",
    link: "/privacypolicy",
    key: "13",
  },
  {
    label: "Feedback",
    description: "Share your experience with us",
    icon: "💬",
    link: "/feedback",
    key: "14",
  },
  {
    label: "Contact Us",
    description: "Get in touch with our team",
    icon: "📧",
    link: "/contact-us",
    key: "15",
  },

  ...(isLoggedIn
    ? [
        {
          label: "Library",
          description: "System management features and tools",
          icon: "🗂️",
          link: null,
          key: "library-parent",
          isParent: true,
          children: [
            {
              label: "License and Capacity Management",
              icon: "📄",
              link: "/license-feature",
              key: "6",
            },
            {
              label: "Partition and User Role Management",
              icon: "📋",
              link: "/partition-management",
              key: "7",
            },
            {
              label: "Schedule and Event Action",
              icon: "🗓️",
              link: "/event-schedule",
              key: "8",
            },
            {
              label: "Threat Level Management",
              icon: "🗂️",
              link: "/threat-manage",
              key: "9",
            },
            {
              label: "Backup and Restore Management",
              icon: "💾",
              link: "/backup-restore",
              key: "10",
            },
            {
              label: "Service Management",
              icon: "⚙️",
              link: "/service-management",
              key: "11",
            },
            {
              label: "Mobile Credential",
              icon: "📱",
              link: "/mobile-credential",
              key: "12",
            },
          ],
        },
      ]
    : []),
];

export const getProductItems = (categories) => [
  {
    label: "All Products",
    description: "Browse our complete product catalog",
    icon: "🏢",
    link: "/product",
    key: "all",
  },
  ...(categories || []).map((category) => ({
    label: capitalizeWords(category?.name), // Capitalize category names
    description: getProductDescription(category?.name),
    icon: "📦",
    link: `/product?category=${category?.name?.toLowerCase()}`,
    key: category?.id,
  })),
];
